import Vue from 'vue'

import {
  Container,
  Header,
  Main,
  Footer,
  Button,
  Menu,
  MenuItem,
  Card,
  Row,
  Col,
  Tag,
  Alert,
  Input,
  Table,
  TableColumn,
  Popover,
  Tooltip,
  Link,
  Image,
  Pagination,
  Form,
  Message,
  MessageBox,
  DatePicker,
  FormItem
} from 'element-ui'

import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'

locale.use(lang)

Vue.use(Container)
Vue.use(Main)
Vue.use(Header)
Vue.use(Footer)
Vue.use(Button)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Tag)
Vue.use(Alert)
Vue.use(Input)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Popover)
Vue.use(Tooltip)
Vue.use(Image)
Vue.use(Link)
Vue.use(Pagination)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(DatePicker)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
